<template lang="html">
  <div>
    <div class="table-responsive">
      <p v-if="!itemList || !Object.keys(itemList).length"><em>no items to show</em></p>
      <table v-if="itemList && Object.keys(itemList).length" class="table table-custom table-striped-custom table-custom-sm">
        <thead>
          <tr>
            <th>Date</th>
            <th>Reason</th>
            <th>Amount</th>
            <th>Guarantor</th>
            <th>Member</th>
            <th>Stripe Customer</th>
            <th>Stripe Invoice</th>
            <th v-if="isCompleteTable">Initials &amp; Timestamp</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, id) in itemList" :key="id">
            <td><span v-if="item.timestamp" :title="item.timestamp | prettyDateTime">{{ item.timestamp | prettyDateShort }}</span></td>
            <td><span v-if="item.reason">{{ item.reason }}</span></td>
            <td><span v-if="item.amount">{{ item.amount | prettyPrice }}</span></td>
            <td>
              <router-link v-if="item.guarantorId" :to="'/guarantor-profile/' + item.guarantorId" target="_blank">
                <i class="far fa-fw fa-external-link-square-alt"></i><name-guarantor :guarantorAccountId="item.guarantorId"></name-guarantor>
              </router-link>
            </td>
            <td>
              <router-link v-if="item.memberId" :to="'/member-profile/' + item.memberId" target="_blank">
                <i class="far fa-fw fa-external-link-square-alt"></i><name-member :memberId="item.memberId"></name-member>
              </router-link>
            </td>
            <td>
              <a
                v-if="environment == 'production' && item.stripe_customer_id"
                target="_blank"
                :href="'https://dashboard.stripe.com/customers/' + item.stripe_customer_id"
              >
                <i class="far fa-fw fa-external-link-square-alt"></i>View Account
              </a>
              <a
                v-if="environment !== 'production' && item.stripe_customer_id"
                target="_blank"
                :href="'https://dashboard.stripe.com/test/customers/' + item.stripe_customer_id"
              >
                <i class="far fa-fw fa-external-link-square-alt"></i>View Account
              </a>
            </td>
            <td>
              <a
                v-if="environment == 'production' && item.stripe_invoice_id"
                target="_blank"
                :href="'https://dashboard.stripe.com/invoices/' + item.stripe_invoice_id"
              >
                <i class="far fa-fw fa-external-link-square-alt"></i>View Invoice
              </a>
              <a
                v-if="environment !== 'production' && item.stripe_invoice_id"
                target="_blank"
                :href="'https://dashboard.stripe.com/test/invoices/' + item.stripe_invoice_id"
              >
                <i class="far fa-fw fa-external-link-square-alt"></i>View Invoice
              </a>
            </td>
            <td v-if="isCompleteTable">
              <span v-if="item.completed_by_initials">{{ item.completed_by_initials }}</span> <span v-if="item.completed_timestemp"> at {{ item.completed_timestemp | prettyDateTimeShort }}</span>
            </td>
            <td>
              <button @click="activeItem = {'item': item, 'id': id}" class="btn btn-link btn-icon-left">
                <span v-if="!item.complete"><i class="far fa-check"></i></span>
                <span v-if="item.complete"><i class="far fa-times"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div> <!-- /.table-responsive -->
    <div class="modal modal-app d-block" v-if="activeItem" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button class="btn btn-light btn-modal-close" @click="activeItem=null;completed_by_initials=null;"><i class="far fa-times"></i></button>
            <h4 v-if="!activeItem.item.complete">Mark Complete</h4>
            <p v-if="!activeItem.item.complete">Enter your initials to mark this item as complete. A timestamp will also be saved.</p>
            <h4 v-if="activeItem.item.complete">Mark Incomplete</h4>
            <p v-if="activeItem.item.complete">Marking incomplete will remove completion timestamp and initials.</p>
            <input v-if="!activeItem.item.complete" v-model="completed_by_initials" name="initials" class="form-control" placeholder="Enter your initials" type="text" @keyup.enter="setItemCompletion"/>
            
            <p class="text-right snug">
              <button @click="setItemCompletion" :disabled="!completed_by_initials && !activeItem.item.complete" class="btn btn-app btn-icon-left">
                <span v-if="!activeItem.item.complete"><i class="far fa-check"></i>Mark Complete</span>
                <span v-if="activeItem.item.complete"><i class="far fa-times"></i>Mark Incomplete</span>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" v-if="activeItem"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import NameMember from '../components/NameMember.vue'
import NameGuarantor from '../components/NameGuarantor.vue'

export default {
  props: ['itemList','isCompleteTable'],
  components: {
    NameMember, NameGuarantor,
  },
  data () {
    return {
      activeItem: null,
      completed_by_initials: null,
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props']),
    environment () {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    setItemCompletion() {
      if(!this.activeItem) {
        console.log('exiting setItemCompletion, no activeItem', this.activeItem);
        return;
      }
      const item = this.activeItem.item;
      const id = this.activeItem.id;
      // console.log(this.user.uid);
      // console.log(this.user_props.owned_account_id);
      // console.log({item});
      // console.log({id});
      if(!this.user || !this.user_props || !this.user_props.owned_account_id) {
        console.log("can't setItemCompletion, missing user data");
        return;
      }
      // update item in firestore to opposite of current complete value
      let newCompletionStatus = !item.complete;
      const updateData = {
        complete: newCompletionStatus,
      };
      if(newCompletionStatus) {
        updateData.completed_by_initials = this.completed_by_initials || null;
        updateData.completed_timestemp = Math.floor(Date.now() / 1000);
      } else {
        updateData.completed_by_initials = null;
        updateData.completed_timestemp = null;
      }
      Vue.firestore
        .doc(`owners/${this.user.uid}/accounts/${this.user_props.owned_account_id}/excluded_payments/${id}`)
        .update(updateData)
        .then((success) => {
          console.log('updated item completion');
          // then manually reactive update item in excludedItems so it moves to opposite list
          // make a copy of item, update it, then bubble it up to reactively update
          const updatedItem = {...item};
          updatedItem.complete = newCompletionStatus;
          updatedItem.completed_by_initials = updateData.completed_by_initials;
          updatedItem.completed_timestemp = updateData.completed_timestemp;
          console.log('setItemCompletion updatedItem',updatedItem);
          this.$emit('update-item', id, updatedItem);
          this.activeItem = null;
          this.completed_by_initials = null;
          return true;
        })
        .catch(err => console.log(err));
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.table tr .btn,
.table tr a {
  display: block;
  width: fit-content;
  white-space: nowrap;
}
// modal overrides
.modal-backdrop {
  background-color: fadeout(#000,20%);
}
.btn-modal-close {
  position: absolute;
  right: 10px;
  top: 10px;
}
.modal h4 {
  margin-bottom: 20px;
}
</style>
